module.exports = __webpack_public_path__ + "static/media/Planilha_de_Importacao_de_Imoveis_de_Empreendimento_-_YouNect .f88bb1b7.xlsx";